import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';
import { ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise';
import { Buffer } from 'buffer';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import { HTML5toTouch } from 'rdndmb-html5-to-touch';
import React, { useState } from 'react';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DndProvider, MouseTransition, MultiBackendOptions, TouchTransition } from 'react-dnd-multi-backend';
import { TouchBackend } from 'react-dnd-touch-backend';
import { I18nextProvider } from 'react-i18next';
import { QueryClient, QueryClientProvider } from 'react-query';
import i18n from './config/i18n';
import { AuthProvider } from './context/AuthContext';
import { ModalProvider } from './context/ModalProvider';
import { OnlineStatusProvider } from './context/OnlineStatusContext';
import { SystemConfigProvider } from './context/SystemConfigContext';
import { ThemeProvider } from './context/ThemeContext';
import Routers from './navigations/Routers';
import './SLTP.css';

dayjs.locale('fr');
ModuleRegistry.registerModules([AllEnterpriseModule.with(AgChartsEnterpriseModule)]);

const AG_GRID_LICENSE = process.env.REACT_APP_AG_GRID_LICENSE_KEY;

if (AG_GRID_LICENSE) {
    LicenseManager.setLicenseKey(AG_GRID_LICENSE);
} else {
    console.warn('AG Grid license key not found in environment variables');
}

const App: React.FC = () => {
    const [queryClient] = useState(
        () =>
            new QueryClient({
                defaultOptions: {
                    queries: {
                        staleTime: 0,
                        refetchOnWindowFocus: false,
                        refetchOnMount: true,
                        retry: false,
                    },
                },
            })
    );

    const HTML5toTouchCustom: MultiBackendOptions = {
        backends: [
            {
                id: 'html5',
                backend: HTML5Backend,
                transition: MouseTransition,
            },
            {
                id: 'touch',
                backend: TouchBackend,
                options: {
                    enableMouseEvents: true,
                },
                preview: true,
                transition: TouchTransition,
            },
        ],
    };

    if (typeof window !== 'undefined') {
        window.Buffer = Buffer;
    }

    return (
        <AuthProvider>
            <OnlineStatusProvider>
                <QueryClientProvider client={queryClient}>
                    <I18nextProvider i18n={i18n}>
                        <SystemConfigProvider>
                            <DndProvider options={HTML5toTouch}>
                                <ThemeProvider>
                                    <ModalProvider>
                                        <Routers />
                                    </ModalProvider>
                                </ThemeProvider>
                            </DndProvider>
                        </SystemConfigProvider>
                    </I18nextProvider>
                </QueryClientProvider>
            </OnlineStatusProvider>
        </AuthProvider>
    );
};

export default App;
